import { InsightType } from 'lib/apis/entity/insight';
import { nFormatter } from 'lib/utils/helpers/numberFormat';
import { useOwnTranslate } from '../../../../lib/hooks/useOwnTranslate';

type Props = {
  stats: InsightType.Stat[];
};

const HousePricesTrendsData = ({ stats }: Props) => {
  const { t } = useOwnTranslate('global');

  return (
    <>
      {stats?.map((c, index) => (

        c.content.map((x) => (
          <div
            key={`${index}_${x.statsKindPhrase}`}
            className="flex flex-col gap-2 w-full"
          >
            <div>
              {x.statsKindPhrase && (
                <p className="text-sm text-grey-700">{x.statsKindPhrase}</p>
              )}
              {c.description && (
                <p className="text-sm text-grey-500">{x.description}</p>
              )}
            </div>
            <div className="flex flex-row justify-start items-center gap-4">
              {x.value ? (
                <span className="text-lg font-semiBold text-nowrap">
                  {nFormatter(+x.value.toFixed())
                    .toString()
                    .concat(' ')
                    .concat(x.symbol === 't' ? t('toman') : '')}
                </span>
              ) : (
                '--'
              )}
            </div>
          </div>
        ))
      ))}
    </>
  );
};

export default HousePricesTrendsData;
